import React, { useState, useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import { iconList } from "react-icomoon";
import { AppContexts } from "../../../providers";
import GuideIcon from "../../common/GuideIcon";
import iconSet from "../../../assets/icons/ruebarue/selection.json";
import UIkit from "uikit";
import { upsertGuideSection } from "./section_state";

const IconList = ({ onSectionSaved }) => {
  const {
    selectedSection,
    setSelectedSection,
    updateSection,
    rental,
    setRental,
  } = useContext(AppContexts.RentalsContext);
  const { refresh, setUser } = useContext(AppContexts.AuthContext);

  const [searchTerm, setSearchTerm] = useState("");
  const allIcons = iconList(iconSet);

  const filteredIcons = allIcons
    .filter((icon) => icon.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort();
  
  const handleSelect = async (icon) => {
    if (!selectedSection.welcome_guide_question_id) return;

    const [saved, error] = await updateSection({
      ...selectedSection,
      icon: `icon-${icon}`,
    });
    if (error || !saved) return;
    onSectionSaved?.(saved);
    await refresh();
    if (rental?.rental_id) {
      setRental((current) => ({
        ...current,
        welcome_guide: upsertGuideSection(current?.welcome_guide, saved),
      }));
    } else {
      setUser((current) => current ? {
        ...current,
        welcome_guide: upsertGuideSection(current.welcome_guide, saved),
      } : current);
    }
    setSelectedSection(saved);
    UIkit.offcanvas("#iconList-modal").hide();
  };

  const clearSearch = () => setSearchTerm("");

  useEffect(() => {
    UIkit.util.on(`#iconList-modal`, "hidden", function (e) {
      clearSearch();
    });
  }, []);

  return createPortal(
    <div
      id="iconList-modal"
      data-guide-editor-offcanvas
      className="uk-modal-full hms-modals uk-modal"
      uk-offcanvas="overlay: true; flip: true; container: true"
    >
      <div className="uk-offcanvas-bar">
        <button
          className="uk-offcanvas-close uk-close-large"
          type="button"
          aria-label="Close icon picker"
          data-uk-close
        ></button>

        <div className="uk-modal-header">
          <h2 className="uk-modal-title">Select an Icon</h2>
        </div>

        <div className="uk-modal-body guide-icon-picker-body">
          <div className="uk-position-relative guide-icon-picker-search">
            <input
              type="text"
              className="uk-input"
              placeholder="Search Icon"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                className="uk-position-center-right uk-button uk-button-text"
                style={{ right: 10, top: "50%", transform: "translateY(-50%)" }}
                onClick={clearSearch}
              >
                ×
              </button>
            )}
          </div>
          <div
            className="uk-child-width-1-6@m guide-icon-picker-grid"
            uk-grid="parallax: 0"
          >
            {filteredIcons.map((icon) => {
              const isSelected = icon === (selectedSection?.icon || "").replace("icon-", "");

              return (
                <div
                  className="uk-inline icon-select"
                  key={icon}
                  onClick={() => handleSelect(icon)}
                  uk-tooltip={icon.charAt(0).toUpperCase() + icon.slice(1)}
                  style={{
                    cursor: "pointer",
                    backgroundColor: isSelected ? "rgb(240, 82, 82)" : undefined,
                  }}
                >
                  <GuideIcon icon={`icon-${icon}`} color={isSelected ? "white" : undefined} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default IconList;
